import { Box } from '@mui/material';
import CompanyTruckImplementsMap from 'app/modules/dashboards/dashboard-company/components/company-truck-implements-tab/CompanyTruckImplementsMap';
import React from 'react';
import { Col, Row } from 'reactstrap';

export const ChecklistFacilCompany = () => {
  return (
    <Box sx={{ height: '100%' }}>
      <CompanyTruckImplementsMap />
    </Box>
  );
};
